<template>
  <section class="result-grid panel panel-default">
    <section class="panel-heading">
      <h3 class="panel-title">
        <span class="required-equity">Required equity:</span>
        <section class="input-group">
          <input
            type="number"
            class="form-control"
            v-bind:value="requiredEquity"
            max="100"
            min="1"
            v-on:input="setRequiredEquityAfterManuallyChanged($event.target.value)"
          >
          <span class="input-group-addon">%</span>
        </section>
        <span class="pot-odds">
          Pot odds:
          <input
            v-model="potOddsLHS"
            type="number"
            class="form-control"
            min="0"
          >
          -to-
          <input
            v-model="potOddsRHS"
            type="number"
            class="form-control"
            min="0"
          >
        </span>
      </h3>
    </section>
    <section class="panel-body">
      <div class="flexbox-container">
        <grid-selector
          v-bind:generalHands="generalHands"
          v-bind:equityMatrix="true"
          v-bind:requiredEquity="requiredEquity"
          v-bind:specificHandsNotAllowed="true"
        />
        <result-table
          v-bind:generalHands="generalHands"
        />
      </div>
    </section>
  </section>
</template>

<script>
import GridSelector from '@/components/hand-range/grid-selector/grid-selector';
import ResultTable from '@/components/equity-matrix/result-table';

export default {
  name: 'equity-matrix-result-grid',
  components: {
    'grid-selector': GridSelector,
    'result-table': ResultTable,
  },
  props: ['generalHands', 'requiredEquity'],
  data: function () {
    return {
      potOddsLHS: 1,
      potOddsRHS: 1,
    };
  },
  watch: {
    potOddsLHS: function () {
      this.setRequiredEquityBasedOnPotOdds();
    },
    potOddsRHS: function () {
      this.setRequiredEquityBasedOnPotOdds();
    },
  },
  methods: {
    setRequiredEquityAfterManuallyChanged: function (requiredEquity) {
      let self = this;

      self.$emit('setRequiredEquity', requiredEquity);
      setTimeout(function () {
        self.setPotOddsBasedOnRequiredEquity();
      }, 50);
    },
    setRequiredEquityBasedOnPotOdds: function () {
      let risk = Number(this.potOddsRHS);
      let reward = Number(this.potOddsLHS);
      let requiredEquity = Math.round((risk / (risk + reward)) * 100);

      this.$emit('setRequiredEquity', requiredEquity);
    },
    setPotOddsBasedOnRequiredEquity: function () {
      this.potOddsRHS = 1;
      this.potOddsLHS = ((100 / this.requiredEquity) - 1).roundToTwoDecimalPlaces();
    },
  },
};
</script>

<style lang="scss" scoped>
  .panel-heading {
    height: 51px;

    .panel-title {
      .required-equity {
        position: relative;
        bottom: 10px;
      }

      .input-group {
        width: 100px;
        display: inline-table;
      }

      .pot-odds {
        margin-left: 25px;
        position: relative;
        bottom: 10px;

        .form-control {
          width: 65px;
          display: inline;
        }
      }
    }
  }

  .flexbox-container {
    .grid-selector {
      flex: 0 1 440px;
    }

    .result-table {
      margin-left: 20px;
      flex: 1;
    }
  }

  @media (max-width: 535px) {
    .flexbox-container {
      display: block;

      .result-table {
        margin-left: 0;
        margin-top: 20px;
        max-width: 353px;
      }
    }

    .panel-heading {
      height: auto;

      .panel-title .pot-odds {
        display: block;
        margin-left: 0px;
        position: static;
        margin-top: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/equity-matrix/result-grid.vue